import { Center, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@revelio/ui';

/**
 * Displays a 404 message for missing Custom Dash pages.
 * Quick access to landing page.
 */
export const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Center w="100%" h="100%" p={4}>
      <VStack spacing={4} textAlign="center">
        <Text fontSize="2xl" fontWeight="bold">
          Page Not Found
        </Text>
        <Text maxW="400px">
          The page you are looking for has been moved or deleted.
        </Text>
        <Button color="primary" onClick={() => navigate('/')}>
          Go to Landing Page
        </Button>
      </VStack>
    </Center>
  );
};
